<script>
import ConstructionPhotoViewer from "../../ConstructionPhotoViewer.vue";

export default {
    name: "ConstructionPhotoTab",
    components: {ConstructionPhotoViewer},
    props: {
        construction: {required: true}
    },
    methods: {
        showGallery(base, index, start = 'photos') {
            this.$refs.gallery.show(base, index, start)
        },
        youtubeId(url) {
            if (!url) return null
            const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^?&\s]+)/)
            return m ? m[1] : null
        },
        youtubeEmbed(url) {
            const id = this.youtubeId(url)
            return id ? `https://www.youtube.com/embed/${id}` : null
        }
    }
}
</script>

<template>
    <div>
        <div class="row">
            <standalone-property-gallery v-ref:gallery></standalone-property-gallery>
            <construction-photo-viewer :photos='construction.photos'
                                       :settings='{time: 2500, displayedThumbs: 2}'></construction-photo-viewer>

            <div class="col-lg-6 col-xs-12">
                <div class="portlet light">
                    <h4 style="margin-bottom:20px"><b>Vídeos</b></h4>
                    <div v-if="construction.videos && construction.videos.length > 0">
                        <div v-for="video in construction.videos" style="margin-bottom: 15px;">
                            <div v-if="youtubeEmbed(video.url)">
                                <iframe :src="youtubeEmbed(video.url)"
                                        width="100%" height="250" frameborder="0"
                                        allowfullscreen style="display:block;"></iframe>
                            </div>
                            <div v-if="!youtubeEmbed(video.url) && video.thumbnail">
                                <img :src="video.thumbnail" width="100%" height="150" style="cursor:pointer; object-fit:cover;">
                            </div>
                            <div v-if="!youtubeEmbed(video.url) && !video.thumbnail">
                                <a :href="video.url" target="_blank" class="btn btn-default btn-sm">
                                    <i class="fa fa-play gap"></i> Ver vídeo
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else>Nenhum vídeo encontrado</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionPhotoTab.vue?5cc20cf7